import React, {createContext, useContext, useEffect, useState} from "react";
import {localeGet} from "../../api/player";
import {parse_url} from "../../common/src";

export const LocaleContext = createContext(null);

export const LocaleProvider = ({children}) => {
    const [localeName, setLocaleName] = useState(null);
    const [locale, setLocale] = useState(null);

    useEffect(() => {
        const request = parse_url(location.href);

        setLocaleName(request.getParameter('lang', 'ru'));
    }, []);

    useEffect(async () => {
        if (!localeName) {
            return;
        }
        const locale = await localeGet(localeName);
        setLocale(locale);
    }, [localeName]);

    if (!locale) {
        return null;
    }

    const context = {
        localeName,
        getName() {
            return localeName;
        },
        locale,
        get(name, params) {
            if (typeof locale[name] === 'undefined') {
                console.log('Cant find locale for', name, localeName);
                return '';
            }

            let result = locale[name];
            if (typeof result === 'string') {
                result = result.replace(/{([-_\w]+)}/g, (all, v) => params[v] || all);
            }

            return result;
        },
        getProperty(object, key, defaultValue) {
            const camelCaseKey = key + localeName.substring(0, 1).toUpperCase() + localeName.substring(1).toLowerCase();
            if (!object) return defaultValue;
            if (object.hasOwnProperty(camelCaseKey)) {
                return object[camelCaseKey];
            }
            const snakeCaseKey = key + '_' + localeName.toLowerCase().substring(0, 2);
            if (object.hasOwnProperty(snakeCaseKey)) {
                return object[snakeCaseKey];
            }
            return defaultValue;
        }
    };

    return (
        <LocaleContext.Provider value={context}>
            {children}
        </LocaleContext.Provider>
    );
}

export const useLocaleContext = () => useContext(LocaleContext);
